DrawerJs = {

  /**
   * All available tool options
   * @memberof DrawerJs
   * @namespace options
   */


  /**
   * Global namespace for all DrawerJs plugins.
   *
   * @memberof DrawerJs
   * @namespace DrawerJs.plugins
   */
  plugins: {},

  /**
   * Global namespace for all DrawerJs utility functions.
   *
   * @memberof DrawerJs
   * @namespace DrawerJs.util
   */
  util: {},

  /**
   * Global namespace for all DrawerJs utility plugins.
   *
   * @memberof DrawerJs
   * @namespace DrawerJs.utilPlugins
   */
  utilPlugins: {},

  /**
   * All drawer brush classes.
   *
   * @memberof DrawerJs
   * @namespace DrawerJs.brushes
   */
  brushes: {}
};
